

import Lunar from '../js/shouxing.js'
import { drawCld } from '../js/calendar.js'
import XButton from 'vux/src/components/x-button/index.vue'

var Today = new Date(1980,0,1);
var tY = Today.getFullYear();
var tM = Today.getMonth();
var tD = Today.getDate();
var tHours = Today.getHours();
var tMinute = Today.getMinutes();
var initialTime;
var selectSolarDate;
var changeCldDate;
export default {
name: 'calendar',
data () {
return {
birthday: '',
SYearData: [],
SMonthData: [],
SHoursData: [],
SMinuteData: [],
tbodyData: [],
selectDay: '1',
changeYear: '1980',
changeMonth: '0',
value:'',
lunar: null,
}
},
components: {
XButton,
},

created: function () {
this.setSYear()
this.setSMonth()


this.setCalendar()
this.lunar = new Lunar();
},

mounted: function () {
this.initCal();
},

methods: {
returnSubmit(){
return
},
setSYear: function () {
var selectYear = document.getElementById('SY')
for (var i = 1901; i < 2050; i++) {
this.SYearData.push(i)
}
},
setSMonth: function () {
var selectMonth = document.getElementById('SM');
for (var i = 1; i < 13; i++) {
this.SMonthData.push(i);
}
},
setCalendar: function () {
var gNum;
for (var i = 0; i< 6; i++) {
var data = [];
for(var j = 0; j < 7; j++) {
gNum = i*7 + j;
data.push({
tdId:'GD' + gNum,
fontOId: 'SD' + gNum,
fontTId: 'LD' + gNum
})
}
this.tbodyData.push(data)
}
},
initCal: function () {
console.log('cldcld:', CLD)
if(this.birthday != '') {
var newDate = this.birthday.split('-');
this.changeYear = newDate[0];
this.changeMonth = (parseInt(newDate[1]) - 1).toString();
this.selectDay = parseInt(newDate[2].split(' ')[0]).toString();
tY = parseInt(newDate[0]);
tM = parseInt(newDate[1]) - 1;
tD = parseInt(newDate[2].split(' ')[0]);
}
CLD.SY.selectedIndex = tY - 1901;
CLD.SM.selectedIndex = tM;
drawCld(tY,tM);
var tMon = (tM+1) > 9 ? (tM+1) : '0' + (tM+1);
var childNode = document.getElementsByTagName('tbody')[0].getElementsByTagName('td');
for(var i = 0; i < childNode.length; i++) {
var inn = parseInt(childNode[i].innerText);
if(inn == tD) {
childNode[i].style.backgroundColor = 'rgb(253, 65, 62)';
childNode[i].getElementsByTagName('span')[0].style.color = '#fff';
childNode[i].getElementsByTagName('span')[1].style.color = '#fff';
} else {
childNode[i].style.backgroundColor = '#fff';
childNode[i].getElementsByTagName('span')[0].style.color = '#333';
childNode[i].getElementsByTagName('span')[1].style.color = '#999';
}
}
tD = parseInt(tD) > 9 ? tD : '0' + parseInt(tD);
initialTime = tY + '-' + tMon + '-' + tD;
document.getElementById('solar').innerText = initialTime;

this.lunar.yueLiCalc(tY, tM + 1);
var lunarD = this.lunar.lun[tD - 1];
document.getElementById('lunar').innerText = lunarD.Lyear2 + '年' + lunarD.Lmc + '月' + lunarD.Ldc;
},
changeCld: function () {
var y,m,d;
y = CLD.SY.selectedIndex + 1901;
m = CLD.SM.selectedIndex;
drawCld(y,m);
if(this.changeYear == y.toString() && this.changeMonth == m.toString()) {
d = this.selectDay;
} else {
d = '1';
this.selectDay = d;
}
this.changeYear = y;
this.changeMonth = m;
var childNode = document.getElementsByTagName('tbody')[0].getElementsByTagName('td');
for(var i = 0; i < childNode.length; i++) {
var inn = parseInt(childNode[i].innerText);
if(d && inn == d) {
childNode[i].style.backgroundColor = 'rgb(253, 65, 62)';
childNode[i].getElementsByTagName('span')[0].style.color = '#fff';
childNode[i].getElementsByTagName('span')[1].style.color = '#fff';
} else {
childNode[i].style.backgroundColor = '#fff';
childNode[i].getElementsByTagName('span')[0].style.color = '#333';
childNode[i].getElementsByTagName('span')[1].style.color = '#999';
}

if(childNode[i].style.backgroundColor == 'rgb(253, 65, 62)') {
d = parseInt(childNode[i].innerText);
}
}
var month = (m+1) > 9 ? (m+1) : '0' + (m+1);
if(month.length > 2) {
month = month.substr(month.length - 2);
}
d = d > 9 ? d : '0' + d;
if(d.length > 2) {
d = d.substr(d.length - 2);
}
changeCldDate = y + '-' + month + '-' + d;
document.getElementById('solar').innerText = changeCldDate;

this.lunar.yueLiCalc(y, m + 1);

var lunarD = this.lunar.lun[d-1];
document.getElementById('lunar').innerText = lunarD.Lyear2 + '年' + lunarD.Lmc + '月' + lunarD.Ldc;
},

clickEvent: function (e) {
e.stopPropagation();
e.preventDefault();
var childNode = document.getElementsByTagName('tbody')[0].getElementsByTagName('td');
var firstNode;
for(var i = 0; i < childNode.length; i++) {
childNode[i].style.backgroundColor = '#fff';
childNode[i].getElementsByTagName('span')[0].style.color = '#333';
childNode[i].getElementsByTagName('span')[1].style.color = '#999';
if((childNode[i].innerText).split('\n')[0] == '1') {
firstNode = childNode[i];
}
}
var aP = '';
if(e.target.localName == 'td'){
aP = e.target;
} else {
aP = e.target.parentNode;
}
var selectVal = (aP.innerText).split('\n');
this.selectDay = selectVal[0];
if(selectVal[0] == '') {
firstNode.style.backgroundColor = 'rgb(253, 65, 62)';
firstNode.getElementsByTagName('span')[0].style.color = '#fff';
firstNode.getElementsByTagName('span')[1].style.color = '#fff';
return false
} else {
firstNode.style.backgroundColor = '#fff'
aP.style.backgroundColor = 'rgb(253, 65, 62)';
aP.getElementsByTagName('span')[0].style.color = '#fff';
aP.getElementsByTagName('span')[1].style.color = '#fff';
}

var year = document.getElementById('SY').value;
var month = document.getElementById('SM').value;
var m = month > 9 ? month : '0' + month;
var d = selectVal[0] > 9 ? selectVal[0] : '0' + selectVal[0];
selectSolarDate = year + '-' + m + '-' + d;
document.getElementById('solar').innerText = selectSolarDate;
this.value = selectSolarDate;
var lunarD = this.lunar.lun[selectVal[0] - 1];
document.getElementById('lunar').innerText = lunarD.Lyear2 + '年' + lunarD.Lmc + '月' + lunarD.Ldc;
},

clickSure: function () {
var selectYMD = document.getElementById('solar').innerText;
var selectLunar = document.getElementById('lunar').innerText;
this.value = selectYMD;
console.log('this.value:', this.value,selectYMD,selectLunar);
this.birthday = this.value;

let data = {
flag: false,
birthday: this.birthday,
lunar: selectLunar,
}
this.$emit('calendarClose', data);
return false
},
close(){
let data = {
flag: false,
}
this.$emit('calendarClose', data);
}
}
}



// WEBPACK FOOTER //
// ./src/components/calendar.vue